import useStatusBarInset from './useStatusBarInset';

export const HEADER_HEIGHT = 48;

const useHeaderHeight = (inset = true): number => {
    const statusBarInset = useStatusBarInset();

    // eslint-disable-next-line no-nested-ternary
    return HEADER_HEIGHT + (inset ? statusBarInset : 0);
};

export default useHeaderHeight;
